import { Injectable, EventEmitter } from '@angular/core'
import PouchDB from 'pouchdb';

@Injectable({
    providedIn: 'root'
})
export class CouchConfigLPService {

    private isInstantiated: boolean;
    private database: any;
    private idkatios: any;
    private listener: EventEmitter<any> = new EventEmitter();
    private aplSyncCouchAuto = true;

    constructor() {
        if (!this.isInstantiated) {
            this.CrearPouchSincronizacion()
        }

    }

    getFlagSyncCouch() {
        var sSUbicacion = sessionStorage.getItem("SUbicacion");
        var oSUbicacion;
        let flag: boolean = true;
        let config;

        if (sSUbicacion) {
            oSUbicacion = JSON.parse(sSUbicacion);
            if (oSUbicacion.M3HUBS && oSUbicacion.M3HUBS[0] && oSUbicacion.M3HUBS[0].Configuracion) {
                config = JSON.parse(oSUbicacion.M3HUBS[0].Configuracion);

                if (config.SyncCouchAuto != null && config.SyncCouchAuto != undefined) {
                    flag = config.SyncCouchAuto;
                }
            }
        }
        return flag;
    }

    public CrearPouchSincronizacion() {

        this.idkatios = this.GetIdKatiosLVL1FromSession();
        this.database = new PouchDB("ConfigLP_" + this.idkatios, { auto_compaction: true });
        console.debug("adapter")
        console.debug(this.database.adapter);
        var sIdkatios: string;

        // this.validarPaquetes()
        this.syncCouch();
        this.isInstantiated = true;
        console.log("********************************** INSTANCE CONFIGLP *****************************************")

    }

    // validarPaquetes() {
    //     if (this.aplPaquetes) {
    //         let ubicacion = this.getUbicacion();
    //         if (ubicacion) {
    //             this.sync(this.GetServer() + "prdsa" + ubicacion + "_" + this.idkatios.toLowerCase());
    //         }
    //         else {
    //             this.sync(this.GetServer() + "prds_" + this.idkatios.toLowerCase());
    //         }
    //     }
    //     else {
    //         this.sync(this.GetServer() + "prds_" + this.idkatios.toLowerCase());
    //     }
    // }

    syncCouch() {
        if (!this.idkatios) {
            this.CrearPouchSincronizacion();
        }
        else {
            this.sync(this.GetServer() + "configlp_" + this.idkatios.toLowerCase());
        }
    }

    getUbicacion() {
        let sSUbicacion = sessionStorage.getItem("SUbicacion");
        let oSUbicacion;

        if (sSUbicacion) {
            oSUbicacion = JSON.parse(sSUbicacion);
            if (oSUbicacion.IDUbicacion) {
                return oSUbicacion.IDUbicacion;
            }
        }
        return null;
    }

    public GetServer(): string {
        //var json = require('../../../assets/Config/config.json');
        var json = require('G:/Desarrollo/BD/WE8/config.json');
        return json.CouchDBM3;
    }

    //Idkatios que se carga, cuando se inicia el redireccionamiento hacia el WE8
    public GetIdKatiosLVL1FromSession() {
        var sSessionLVL1M3 = sessionStorage.getItem("SessionLVL1M3");
        var oSessionLVL1M3;
        if (sSessionLVL1M3 !== undefined && sSessionLVL1M3 != null) {
            oSessionLVL1M3 = JSON.parse(sSessionLVL1M3);
            if (oSessionLVL1M3.UsuarioSistema.IDKATIOS !== undefined && oSessionLVL1M3.UsuarioSistema.IDKATIOS != null) {
                return oSessionLVL1M3.UsuarioSistema.IDKATIOS;
            }
        }
        return null;
    }

    //Idkatios que se carga, cuando se inicia el redireccionamiento hacia el WE8
    // public GetKatiosM3FromSession() {
    //     var Katios = sessionStorage.getItem("ConfigKatios" + this.idkatios.toUpperCase());
    //     if (Katios !== undefined && Katios != null) {
    //         var jKatiosM3 = JSON.parse(Katios);
    //         if (jKatiosM3 && jKatiosM3.KatiosM3 && jKatiosM3.KatiosM3.aplPaqs) {
    //             this.aplPaquetes = jKatiosM3.KatiosM3.aplPaqs
    //         }
    //     }
    // }

    public async Destroy(idkatios) {
        var respuesta;
        respuesta = await this.database.destroy()
        return respuesta
    }



    public sync(remote: string) {
        this.aplSyncCouchAuto = this.getFlagSyncCouch();
        let remoteDatabase = new PouchDB(remote, { auto_compaction: true });

        this.database.replicate.from(remoteDatabase, {
            live: this.aplSyncCouchAuto,
            retry: true
        }).on('complete', change => {

            console.log("********************************** COMPLETO CAMBIO CONFIGLP *****************************************")
        }).on('change', change => {
            this.listener.emit(change);
            console.log("********************************** CHANGE CAMBIO CONFIGLP *****************************************")
        }).on('error', function (err) {
            console.log("Error")
            // boo, something went wrong!
        });
    }

    public get(id: string) {
        return this.database.get(id);
    }

    public fetch() {
        return this.database.allDocs({ include_docs: true });
    }

    public getEncabezado() {
        return this.database.allDocs({ include_docs: false });
    }

    public getInfo() {
        return this.database.info();
    }

    public getChangeListener() {
        return this.listener;
    }

    public deleteLp(id) {
        this.database.get(id).then(result => {
            return this.database.remove(result);
        });
    }

    public DeleteAllDocs() {
        this.database.allDocs({ include_docs: true }).then(allDocs => {
            return allDocs.rows.map(row => {
                return { _id: row.id, _rev: row.doc._rev, _deleted: true };
            });
        }).then(deleteDocs => {
            return this.database.bulkDocs(deleteDocs);
        });
    }


}